// extracted by mini-css-extract-plugin
export default {"thumbnails_image":"car-section_thumbnails_image__cIjqT","thumbnails_image_container":"car-section_thumbnails_image_container__LWbtq","gallery_item":"car-section_gallery_item__HzS6f"};